const CLIENT_SOURCE = 'magellan-international-website';
const REQUEST_ID_PATTERN = /^[a-z0-9._:-]{8,160}$/i;
const ENABLE_PUBLIC_REQUEST_HEADERS = !['false', '0', 'off', 'no'].includes(String(process.env.REACT_APP_ENABLE_PUBLIC_REQUEST_HEADERS || 'true')
  .trim()
  .toLowerCase());

function sanitizeText(value, maxLength = 180) {
  return String(value || '').trim().slice(0, maxLength);
}

function randomHexFallback() {
  return Array.from({ length: 4 }, () => Math.floor(Math.random() * 0xffffffff).toString(16).padStart(8, '0')).join('');
}

export function sanitizePublicRequestId(value) {
  const normalized = sanitizeText(value).replace(/[^a-z0-9._:-]+/gi, '-');
  return REQUEST_ID_PATTERN.test(normalized) ? normalized : '';
}

export function createPublicRequestId(prefix = 'public') {
  const cleanPrefix = sanitizeText(prefix, 32).toLowerCase().replace(/[^a-z0-9]+/g, '-') || 'public';
  const randomId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : randomHexFallback();
  return `${cleanPrefix}:${Date.now().toString(36)}:${randomId}`.slice(0, 160);
}

export function resolvePublicRequestId(payload = {}, prefix = 'public') {
  return sanitizePublicRequestId(payload.publicRequestId)
    || sanitizePublicRequestId(payload.websiteRequestId)
    || sanitizePublicRequestId(payload.requestId)
    || createPublicRequestId(prefix);
}

export function buildPublicRequestHeaders(headers = {}, requestId = '') {
  const publicRequestId = sanitizePublicRequestId(requestId) || createPublicRequestId('public');
  if (!ENABLE_PUBLIC_REQUEST_HEADERS) {
    return { ...headers };
  }

  return {
    ...headers,
    'X-Client-Source': CLIENT_SOURCE,
    'X-Request-ID': publicRequestId,
    'X-Idempotency-Key': publicRequestId,
  };
}

export function attachPublicRequestMetadata(payload = {}, requestId = '') {
  const publicRequestId = sanitizePublicRequestId(requestId) || createPublicRequestId('public');
  return {
    ...payload,
    publicRequestId,
    websiteRequestId: publicRequestId,
    clientSource: CLIENT_SOURCE,
  };
}
